import { PreloadableRouteObject, TFileToRouteMap } from '~/app/models'
import { getRoutesFromMap } from '~/app/utils/lazy'
import { EClientPath } from '~/models/api'

const quotesRoutesFileToRouteMap: TFileToRouteMap = {
  quoteDetail: {
    path: EClientPath.quote,
    getImportPromise: () => import('~/pages/quotes/quote'),
  },
}

const quotesRoutes: PreloadableRouteObject[] = getRoutesFromMap(
  quotesRoutesFileToRouteMap,
)

export default quotesRoutes
